// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_5c852bb","breadcrumbs":"_4617250","breadcrumbsItem":"_0ef2ecf","active":"_f67d213"};